export enum Feature {
  DASHBOARD = "f1f1f1f1-f1f1-f1f1-f1f1-f1f1f1f1f1f1",
  SALES = "f2f2f2f2-f2f2-f2f2-f2f2-f2f2f2f2f2f2",
  FINANCE = "fcfcfcfc-fcfc-fcfc-fcfc-fcfcfcfcfcfc",
  INVENTORY = "f3f3f3f3-f3f3-f3f3-f3f3-f3f3f3f3f3f3",
  PURCHASING = "f4f4f4f4-f4f4-f4f4-f4f4-f4f4f4f4f4f4",
  CUSTOMER = "f5f5f5f5-f5f5-f5f5-f5f5-f5f5f5f5f5f5",
  BRANCHES = "fdfdfdfd-fdfd-fdfd-fdfd-fdfdfdfdfdfd",
  REPORT = "f6f6f6f6-f6f6-f6f6-f6f6-f6f6f6f6f6f6",
  EMPLOYEE = "f7f7f7f7-f7f7-f7f7-f7f7-f7f7f7f7f7f7",
  ADMIN = "f8f8f8f8-f8f8-f8f8-f8f8-f8f8f8f8f8f8",
  RAW_MATERIAL = "f9f9f9f9-f9f9-f9f9-f9f9-f9f9f9f9f9f9",
  INTEGRATIONS = "faaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa",
}

export const FeatureInfo = {
  [Feature.DASHBOARD]: {
    name: "Dashboard",
    code: "dashboard",
    icon: "dashboard",
    order: 1,
  },
  [Feature.SALES]: {
    name: "POS & Sales",
    code: "pos",
    icon: "point_of_sale",
    order: 2,
  },
  [Feature.FINANCE]: {
    name: "Finance & Accounting",
    code: "finance",
    icon: "account_balance",
    order: 3,
  },
  [Feature.INVENTORY]: {
    name: "Inventory",
    code: "products",
    icon: "inventory_2",
    order: 4,
  },
  [Feature.PURCHASING]: {
    name: "Purchasing",
    code: "purchases",
    icon: "shopping_cart",
    order: 5,
  },
  [Feature.CUSTOMER]: {
    name: "Customers",
    code: "customers",
    icon: "groups",
    order: 6,
  },
  [Feature.BRANCHES]: {
    name: "Branches & Locations",
    code: "branches",
    icon: "store",
    order: 7,
  },
  [Feature.REPORT]: {
    name: "Reports",
    code: "reports",
    icon: "assessment",
    order: 8,
  },
  [Feature.EMPLOYEE]: {
    name: "HR Management",
    code: "hr",
    icon: "badge",
    order: 9,
  },
  [Feature.ADMIN]: {
    name: "Administration",
    code: "admin",
    icon: "admin_panel_settings",
    order: 10,
  },
  [Feature.RAW_MATERIAL]: {
    name: "Raw Materials",
    code: "raw_materials",
    icon: "layers",
    order: 11,
  },
  [Feature.INTEGRATIONS]: {
    name: "Integrations",
    code: "integrations",
    icon: "api",
    order: 12,
  },
} as const;

export const getFeatureName = (value: Feature): string =>
  FeatureInfo[value].name;
export const getFeatureCode = (value: Feature): string =>
  FeatureInfo[value].code;
export const getFeatureIcon = (value: Feature): string =>
  FeatureInfo[value].icon;
export const getFeatureOrder = (value: Feature): number =>
  FeatureInfo[value].order;

export enum SubFeature {
  DASHBOARD_OVERVIEW = "s1111111-1111-1111-1111-111111111111",

  SALES_BILLING = "s2222222-2222-2222-2222-222222222222",
  SALES_HISTORY = "s2222222-2222-2222-2222-222222222223",
  SALES_RETURN = "s3333333-3333-3333-3333-333333333333",
  SALES_QUOTATION = "s2222222-2222-2222-2222-222222222224",
  REPAIR_JOBS = "s3333333-3333-3333-3333-333333333399",

  SALES_EXPENSES = "s4444444-4444-4444-4444-444444444444",
  SALES_CHEQUES = "s5555555-5555-5555-5555-555555555555",
  BANK_MANAGE = "sg777777-7777-7777-7777-777777777777",

  PRODUCT_MANAGE = "s6666666-6666-6666-6666-666666666666",
  BARCODE_EDITOR = "s6666666-6666-6666-6666-666666666667",
  STOCK_ADJUSTMENT = "s8888888-8888-8888-8888-888888888888",
  STOCK_ADJUSTMENT_HISTORY = "s8888888-8888-8888-8888-88888888888b",
  STOCK_TRANSFER = "s8888888-8888-8888-8888-88888888888a",

  PURCHASE_MANAGE = "s9999999-9999-9999-9999-999999999999",
  SUPPLIER_MANAGE = "saaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa",

  CUSTOMER_MANAGE = "sbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb",

  STORE_MANAGE = "sg444444-4444-4444-4444-444444444444",

  REPORT_SALES = "sccccccc-cccc-cccc-cccc-cccccccccccc",
  REPORT_INVENTORY = "sddddddd-dddd-dddd-dddd-dddddddddddd",

  EMPLOYEE_MANAGE = "sg111111-1111-1111-1111-111111111111",
  ATTENDANCE_MANAGE = "sg111111-1111-1111-1111-111111111112",
  PAYROLL_MANAGE = "sg111111-1111-1111-1111-111111111113",
  SALARY_COMPENSATION = "sg111111-1111-1111-1111-111111111115",
  LEAVE_MANAGE = "sg111111-1111-1111-1111-111111111114",

  USER_MANAGE = "sg222222-2222-2222-2222-222222222222",
  ACCESS_POLICIES = "sg888888-8888-8888-8888-888888888888",

  RAW_MATERIAL_MANAGE = "sr111111-1111-1111-1111-111111111111",
  RAW_MATERIAL_PURCHASE = "sr222222-2222-2222-2222-222222222222",
  RECIPE_MANAGE = "sr333333-3333-3333-3333-333333333333",
  PRODUCTION_MANAGE = "sr444444-4444-4444-4444-444444444444",

  WHATSAPP_CHATBOT = "sa111111-1111-1111-1111-111111111111",
  ONLINE_ORDERS = "sa222222-2222-2222-2222-222222222222",
}

export const SubFeatureInfo = {
  [SubFeature.DASHBOARD_OVERVIEW]: {
    feature: Feature.DASHBOARD,
    name: "Overview",
    icon: "dashboard",
  },

  [SubFeature.SALES_BILLING]: {
    feature: Feature.SALES,
    name: "Billing",
    icon: "receipt",
  },
  [SubFeature.SALES_HISTORY]: {
    feature: Feature.SALES,
    name: "Sales History",
    icon: "history",
  },
  [SubFeature.SALES_RETURN]: {
    feature: Feature.SALES,
    name: "Returns",
    icon: "assignment_return",
  },
  [SubFeature.SALES_QUOTATION]: {
    feature: Feature.SALES,
    name: "Quotations",
    icon: "request_quote",
  },
  [SubFeature.REPAIR_JOBS]: {
    feature: Feature.SALES,
    name: "Repair Jobs",
    icon: "build",
  },

  [SubFeature.SALES_EXPENSES]: {
    feature: Feature.FINANCE,
    name: "Expenses",
    icon: "money_off",
  },
  [SubFeature.SALES_CHEQUES]: {
    feature: Feature.FINANCE,
    name: "Cheque Management",
    icon: "payments",
  },
  [SubFeature.BANK_MANAGE]: {
    feature: Feature.FINANCE,
    name: "Bank Accounts",
    icon: "account_balance",
  },

  [SubFeature.PRODUCT_MANAGE]: {
    feature: Feature.INVENTORY,
    name: "Products",
    icon: "inventory",
  },
  [SubFeature.BARCODE_EDITOR]: {
    feature: Feature.INVENTORY,
    name: "Barcode Label Editor",
    icon: "qr_code",
  },
  [SubFeature.STOCK_ADJUSTMENT]: {
    feature: Feature.INVENTORY,
    name: "Stock Adjustments",
    icon: "sync_alt",
  },
  [SubFeature.STOCK_ADJUSTMENT_HISTORY]: {
    feature: Feature.INVENTORY,
    name: "Stock Adjustment History",
    icon: "history",
  },
  [SubFeature.STOCK_TRANSFER]: {
    feature: Feature.INVENTORY,
    name: "Stock Transfer",
    icon: "swap_horiz",
  },

  [SubFeature.PURCHASE_MANAGE]: {
    feature: Feature.PURCHASING,
    name: "Purchase Orders",
    icon: "shopping_cart",
  },
  [SubFeature.SUPPLIER_MANAGE]: {
    feature: Feature.PURCHASING,
    name: "Suppliers",
    icon: "local_shipping",
  },

  [SubFeature.CUSTOMER_MANAGE]: {
    feature: Feature.CUSTOMER,
    name: "Customers",
    icon: "groups",
  },

  [SubFeature.STORE_MANAGE]: {
    feature: Feature.BRANCHES,
    name: "Stores",
    icon: "store",
  },
  [SubFeature.REPORT_SALES]: {
    feature: Feature.REPORT,
    name: "Sales Reports",
    icon: "assessment",
  },
  [SubFeature.REPORT_INVENTORY]: {
    feature: Feature.REPORT,
    name: "Inventory Reports",
    icon: "assessment",
  },
  [SubFeature.EMPLOYEE_MANAGE]: {
    feature: Feature.EMPLOYEE,
    name: "Employee Registry",
    icon: "badge",
  },
  [SubFeature.ATTENDANCE_MANAGE]: {
    feature: Feature.EMPLOYEE,
    name: "Attendance Register",
    icon: "event_available",
  },
  [SubFeature.PAYROLL_MANAGE]: {
    feature: Feature.EMPLOYEE,
    name: "Payroll Management",
    icon: "receipt_long",
  },
  [SubFeature.SALARY_COMPENSATION]: {
    feature: Feature.EMPLOYEE,
    name: "Salary Compensation",
    icon: "payments",
  },
  [SubFeature.LEAVE_MANAGE]: {
    feature: Feature.EMPLOYEE,
    name: "Leave Calendar",
    icon: "calendar_today",
  },

  [SubFeature.USER_MANAGE]: {
    feature: Feature.ADMIN,
    name: "Users",
    icon: "person",
  },
  [SubFeature.ACCESS_POLICIES]: {
    feature: Feature.ADMIN,
    name: "Access Policies",
    icon: "policy",
  },
  [SubFeature.RAW_MATERIAL_MANAGE]: {
    feature: Feature.RAW_MATERIAL,
    name: "Raw Materials",
    icon: "category",
  },
  [SubFeature.RAW_MATERIAL_PURCHASE]: {
    feature: Feature.RAW_MATERIAL,
    name: "Raw Purchases",
    icon: "shopping_cart",
  },
  [SubFeature.RECIPE_MANAGE]: {
    feature: Feature.RAW_MATERIAL,
    name: "Recipes",
    icon: "restaurant_menu",
  },
  [SubFeature.PRODUCTION_MANAGE]: {
    feature: Feature.RAW_MATERIAL,
    name: "Production",
    icon: "precision_manufacturing",
  },

  [SubFeature.WHATSAPP_CHATBOT]: {
    feature: Feature.INTEGRATIONS,
    name: "WhatsApp Chatbot",
    icon: "sms",
  },
  [SubFeature.ONLINE_ORDERS]: {
    feature: Feature.INTEGRATIONS,
    name: "Online Orders",
    icon: "shopping_cart",
  },
} as const;

export const getSubFeatureName = (value: SubFeature): string =>
  SubFeatureInfo[value].name;
export const getSubFeatureFeature = (value: SubFeature): Feature =>
  SubFeatureInfo[value].feature;
export const getSubFeatureIcon = (value: SubFeature): string =>
  SubFeatureInfo[value].icon;
export const getSubFeatureCode = (value: SubFeature): string =>
  value.toLowerCase();
